import { passwordConfig } from '../services/password-config.service';
import {
  confirmEmailCodeLength,
  idStringLength,
  nameMaxLength,
  orgNameMaxLength,
  tagNameMaxLength,
  tokenStringLength,
} from '../services/utils.service';

// AJVVersion9 JSONSchemaType<string>
export const idSchema = {
  type: 'string',
  format: 'idFormat',
  minLength: idStringLength,
  maxLength: idStringLength,
};
export const idOrNullSchema = { ...idSchema, nullable: true };

export const tokenSchema = {
  type: 'string',
  format: 'tokenFormat',
  minLength: tokenStringLength,
  maxLength: tokenStringLength,
};

export const timestampSchema = { type: 'integer', minimum: 0 };
export const timestampOrNullSchema = { ...timestampSchema, nullable: true };

export const hashSchema = {
  type: 'string',
  format: 'hex',
  minLength: 64,
  maxLength: 64,
};
export const hashOrNullSchema = { ...hashSchema, nullable: true };

// AJVVersion9 JSONSchemaType<string>
export const hash64Schema = {
  type: 'string',
  format: 'base64',
  minLength: 44,
  maxLength: 44,
};
export const hash64OrNullSchema = { ...hash64Schema, nullable: true };

export const colorSchema = { type: 'integer', minimum: 0, maximum: 359 };
export const colorOrNullSchema = { ...colorSchema, nullable: true };

export const confirmEmailCodeSchema = {
  type: 'string',
  format: 'confirmEmailCodeFormat',
  minLength: confirmEmailCodeLength,
  maxLength: confirmEmailCodeLength,
};

export const passwordSchema = {
  type: 'string',
  minLength: passwordConfig.minLength,
  maxLength: passwordConfig.maxLength,
};

export const nameSchema = {
  type: 'string',
  minLength: 1,
  maxLength: nameMaxLength,
};

export const orgNameSchema = {
  type: 'string',
  minLength: 1,
  maxLength: orgNameMaxLength,
};

export const tagNameSchema = {
  type: 'string',
  minLength: 1,
  maxLength: tagNameMaxLength,
};

export const emailSchema = { type: 'string', format: 'email' };

export const trackViewUrlSchema = {
  type: 'string',
  minLength: 1,
  maxLength: 2048,
};

export const trackViewTitleSchema = {
  type: 'string',
  minLength: 1,
  maxLength: 256,
};

export type TrackReqBody = {
  url: string;
  title: string;
  clientId?: string;
  referrer?: string;

  utm_source?: string;
  utm_medium?: string;
  utm_campaign?: string;
  utm_content?: string;
  utm_term?: string;

  dclid?: string;
  fbclid?: string;
  gclid?: string;
  ko_click_id?: string;
  li_fat_id?: string;
  msclkid?: string;
  ttclid?: string;
  twclid?: string;
  wbraid?: string;
};

const trackFieldSchema = { type: 'string', maxLength: 100 };

export const trackBodySchema = {
  type: 'object',
  properties: {
    url: trackViewUrlSchema,
    title: trackViewTitleSchema,
    clientId: idSchema,
    referrer: trackViewUrlSchema,

    utm_source: trackFieldSchema,
    utm_medium: trackFieldSchema,
    utm_campaign: trackFieldSchema,
    utm_content: trackFieldSchema,
    utm_term: trackFieldSchema,

    dclid: trackFieldSchema,
    fbclid: trackFieldSchema,
    gclid: trackFieldSchema,
    ko_click_id: trackFieldSchema,
    li_fat_id: trackFieldSchema,
    msclkid: trackFieldSchema,
    ttclid: trackFieldSchema,
    twclid: trackFieldSchema,
    wbraid: trackFieldSchema,
  },
  required: ['url', 'title'],
  additionalProperties: false,
};
